import {  Input, Switch } from "antd";

function LatLong({setBtnHandler,setCoordinateArray,setSearchState,searchState}) {
  return (
    <div>
      {" "}
      <div
        className="flex flex-row items-center inner-box-hover w-[60vw] max-w-[500px] relative h-[34px] 
max-lg:flex-col max-lg:gap-3 "
      >
        <Input
          autoComplete="nope"
          // suffixIcon={<SearchOutlined />}
          showSearch
          // defaultValue={defaultValue ? defaultValue : null}
          optionFilterProp="label"
          placeholder="برای مثال 36.3455,44.2456"
          className="lg:w-2/3 max-lg:w-full !bg-none !border-none hover:!bg-[#edf2f8] focus:!bg-[#edf2f8] focus:border-none rounded-xl focus:!shadow-none"
          onChange={(e) => {
            setCoordinateArray([
              Number(e.target.value.split(",")[0]),
              Number(e.target.value.split(",")[1]),
            ]);
            setBtnHandler(e.target.value);
          }}
        />

        <div className="flex flex-row items-center gap-2 ml-1 max-lg:bg-[#00000062] max-lg:p-1 max-lg:rounded-2xl ">
          <p className="text-sm whitespace-nowrap max-lg:text-white ">
            جستجو پیشرفته:
          </p>
          <Switch
            className="bg-agroyar hover:!bg-agroyar"
            onChange={(e) => {
              setSearchState(e);
            }}
            checked={searchState}
            checkedChildren="غیرفعال"
            unCheckedChildren="فعال"
          />
        </div>
      </div>
    </div>
  );
}

export default LatLong;
